import type { IUnifiedOrderBlotterEntry } from 'apiConnector/blotters';
import type { IBlotterPreferenceState } from 'components/shared/Blotter/Grid/blotter.model';
import { createSelector } from 'reselect';
import type { IBlotterColumnDefinition } from 'state/blotters/common/blotter.model';
import type { AppState } from 'state/state.model';

function getBlotterState(state: AppState) {
  return state.blotters.secondaryMarketOrder;
}
export function getColumnDefinition(state: AppState): readonly IBlotterColumnDefinition<IUnifiedOrderBlotterEntry>[] {
  return getBlotterState(state).columnDefinition;
}

const emptyItems: readonly [] = [];
export function getPageItems(state: AppState) {
  const { items } = getBlotterState(state);
  return Array.isArray(items) && items.length > 0 ? items : emptyItems;
}

export const getOrderById: (state: AppState, orderId?: string) => IUnifiedOrderBlotterEntry | undefined =
  createSelector(
    [(s: AppState) => s.blotters.secondaryMarketOrder.items, (_s: AppState, orderId?: string) => orderId],
    (orders: readonly IUnifiedOrderBlotterEntry[] | undefined, orderId?: string) =>
      orders?.find(order => order.orderId === orderId),
  );

export function getPreferenceState(state: AppState): IBlotterPreferenceState {
  return getBlotterState(state).blotterPreferenceState;
}

export function isLoading(state: AppState): boolean {
  return getBlotterState(state).loading;
}

export function isInError(state: AppState): boolean {
  return getBlotterState(state).error;
}

export function canSaveBlotterPreferences(state: AppState): boolean {
  return state.blotters.secondaryMarketOrder.canSaveBlotterPreferences;
}
export function getDisplayedItemsCnt(state: AppState): number {
  return getBlotterState(state).displayedItemsCnt;
}
